import ModelVersionsAPI from "../API/modelVersions.api";
import ProductVersionAPI from "../API/productVersion.api";
import { getEncodedValue } from "./Helpers";

const uniqueModelVersionName = async (
    setError,
    setIsFormValid,
    modelParameterId,
    versionName,
    versionId
) => {
    const formattedVersionName = getEncodedValue(versionName);
    const result = await ModelVersionsAPI.checkVersionName(
        modelParameterId,
        formattedVersionName,
        versionId || ""
    );

    if (result?.isUnique) {
        return false;
    } else {
        setError((prevError) => ({
            ...prevError,
            version: "Version Name must be unique",
        }));
        setIsFormValid(false);
        return true;
    }
};

const uniqueProductVersionName = async (
    setError,
    setIsFormValid,
    productId,
    versionName,
    versionNameProp
) => {
    const formattedVersionName = getEncodedValue(versionName);
    const result = await ProductVersionAPI.checkVersionName(
        productId,
        formattedVersionName
    );

    if (result?.isUnique) {
        return false;
    } else {
        setError((prevError) => ({
            ...prevError,
            [versionNameProp]: "Version Name must be unique",
        }));
        setIsFormValid(false);
        return true;
    }
};

export { uniqueModelVersionName, uniqueProductVersionName };
